<template>
  <div>
    <ul class="flex gap-2 flex-wrap">
      <li :class="{'bg-success text-white': $i18n.locale === 'en' }" class="flex items-center cursor-pointer p-2 hover:border-grey-light hover:text-primary" @click="updateLocale('en')">
        <img class="h-5 w-6 mr-1" src="../../assets/images/flags/en.png" alt="en" /> <span>English</span>
      </li>
      <li :class="{'bg-success text-white': $i18n.locale === 'fr' }" class="flex items-center cursor-pointer p-2 hover:border-grey-light hover:text-primary" @click="updateLocale('fr')">
        <img class="h-5 w-6 mr-1" src="../../assets/images/flags/fr.png" alt="fr" /> <span>French</span>
      </li>
      <li :class="{'bg-success text-white': $i18n.locale === 'sp' }" class="flex items-center cursor-pointer p-2 hover:border-grey-light hover:text-primary" @click="updateLocale('sp')">
        <img class="h-5 w-6 mr-1" src="../../assets/images/flags/sp.png" alt="sp" /> <span>Spanish</span>
      </li>
      <li :class="{'bg-success text-white': $i18n.locale === 'ru' }" class="flex items-center cursor-pointer p-2 hover:border-grey-light hover:text-primary" @click="updateLocale('ru')">
        <img class="h-5 w-6 mr-1" src="../../assets/images/flags/ru.jpg" alt="ru" /> <span>Russian</span>
      </li>
      <li :class="{'bg-success text-white': $i18n.locale === 'uz' }" class="flex items-center cursor-pointer p-2 hover:border-grey-light hover:text-primary" @click="updateLocale('uz')">
        <img class="h-5 w-6 mr-1" src="../../assets/images/flags/uz.jpg" alt="uz" /> <span>Uzbek</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  computed: {

  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale
    }
  }
}
</script>